/* eslint-disable no-unused-vars */
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext.js";
import { useWindowSize } from "react-hooks-window-size";
import TokenService from "./services/token.service.js";
import {
	NotFound,
	NotAuthorized,
	Login,
	Dashboard,
	Calendar,
	EventList,
	Notification,
	MobileEventList,
	Profile,
} from "./screens";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0,
			// retry: false,
			// refetchOnWindowFocus: false,
		},
	},
});

function App() {
	const screenSize = useWindowSize();
	const desktopView = screenSize.width > 968;
	const mobileView = screenSize.width < 968;
	const user = TokenService.getUser("user");
	const userName = user?.name;

	return (
		<QueryClientProvider client={queryClient}>
			<Routes>
				<Route path="*" element={<NotFound />} />
				<Route path="/403" element={<NotAuthorized />} />
				<Route exact path="/" element={<Login />} />
				<Route
					exact
					path="/dashboard"
					element={
						<AppProvider>
							<Dashboard />
						</AppProvider>
					}
				>
					<Route path="/dashboard/calendar" element={<Calendar />} />
					<Route
						path="/dashboard/event-list"
						element={desktopView ? <EventList /> : <MobileEventList />}
					/>
					<Route path="/dashboard/notification" element={<Notification />} />
					{mobileView ? (
						<Route
							path="/dashboard/profile"
							element={<Profile user={userName} />}
						/>
					) : null}
				</Route>
			</Routes>

			<ToastContainer />
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	);
}

export default App;
